import { getNounStem } from "./common.js";
import { bincludes, vowels, vowelCount } from "../utils/alphabet.js";
import { toLowerCaseRu } from "../utils/letterCase.js";
import { init, last, takeLast, hasChar, endsWithAny } from "../utils/strings.js";

const NOM = 0;
const GEN = 1;
const DAT = 2;
const ACC = 3;
const INS = 4;
const PREP = 5;
const LOC = 6;

export function decline2(engine, lemma, caseIndex) {
    const word = lemma.text();
    const lcWord = lemma.lower();

    const stem = getNounStem(lemma, lcWord);
    const lcStem = toLowerCaseRu(stem);

    const head = init(word);
    const lcHead = init(lcWord);

    const soft = () => {
        return last(lcWord) === 'я';
    };
    const ayaWord = () => {
        return lcWord.endsWith('ая') && !((vowelCount(lcWord) === 2) || bincludes(vowels, last(lcStem)));
    };
    const yayaWord = () => {
        return lcWord.endsWith('яя') && !((vowelCount(lcWord) === 2) || bincludes(vowels, last(lcStem)));
    };
    const ayaExceptions = [
        'жая', 'шая'
    ];
    switch (caseIndex) {
        case NOM:
            return word;

        case GEN:
            if (yayaWord() || endsWithAny(lcWord, ayaExceptions)) {
                return stem + 'ей';
            } else if (ayaWord()) {
                return stem + 'ой';
            } else if (lemma.isASurname() && !lcWord.endsWith('да')) {
                return head + 'ой';
            } else if (lcWord.endsWith('ничья')) {
                return head + 'ей';
            } else if (
                soft() || bincludes(0b11101000000000010001001000, last(lcStem))  // soft, sibilant or velar
            ) {
                return head + 'и';
            }
            return head + 'ы';

        case DAT:
            if (yayaWord() || endsWithAny(lcWord, ayaExceptions)) {
                return stem + 'ей';
            } else if (ayaWord()) {
                return stem + 'ой';
            } else if (lemma.isASurname() && !lcWord.endsWith('да')) {
                return head + 'ой';
            } else if (takeLast(lcWord, 2) === 'ия') {
                return head + 'и';
            } else if (lcWord.endsWith('ничья')) {
                return head + 'ей';
            }
            return head + 'е';

        case ACC:
            if (ayaWord()) {
                return stem + 'ую';
            } else if (yayaWord()) {
                return stem + 'юю';
            } else if (soft()) {
                return head + 'ю';
            }
            return head + 'у';

        case INS:
            if (yayaWord() || endsWithAny(lcWord, ayaExceptions)) {
                return stem + 'ею';
            } else if (ayaWord()) {
                return [stem + 'ой', stem + 'ою'];
            } else if (soft() ||
                    (hasChar('жшчщц', last(lcStem)) &&
                        !(engine.sd.hasStressedEndingSingular(lemma, caseIndex).includes(true)))) {
                if ('и' === last(lcHead)) {
                    return head + 'ей';
                } else {
                    return [head + 'ей', head + 'ею'];
                }
            }
            return [head + 'ой', head + 'ою'];

        case PREP:
        case LOC:
            if (yayaWord() || endsWithAny(lcWord, ayaExceptions)) {
                return stem + 'ей';
            } else if (ayaWord()) {
                return stem + 'ой';
            } else if (lemma.isASurname() && !lcWord.endsWith('да')) {
                return head + 'ой';
            } else if (takeLast(lcWord, 2) === 'ия') {
                return head + 'и';
            } else if (lcWord.endsWith('ничья')) {
                return head + 'ей';
            }
            return head + 'е';
    }
}
